module.exports = __webpack_public_path__ + "img/nut_washer_hole_indent.ab2d558c.webp";